import { combineReducers } from 'redux'

import { FETCH_RESOURCES_ASYNC } from './constants'

function activitiesReducer() {
  const initialState = {
    data: {},
    loader: false,
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case FETCH_RESOURCES_ASYNC.INITIATE:
        return { ...state, loader: true }
      case FETCH_RESOURCES_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case FETCH_RESOURCES_ASYNC.ERROR:
        return { ...state, error: action.error }
      case FETCH_RESOURCES_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}

export default function () {
  const initialState = combineReducers({
    self: activitiesReducer(),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
